export default __webpack_public_path__ + "static/media/cos_center_logo_small.70948a94.png";